module.exports = __webpack_public_path__ + "img/draw-card.fb1ebdc4.svg";